import { Column } from "@/components/Datatable/types";
import { TransactionHistoryReportItem } from "../../api/fetchTransactionHistoryReport/types";

export function transactionHistoryReportColumns(): Column<TransactionHistoryReportItem>[] {
  return [
    {
      header: "Date",
      accessorKey: "date",
      enableSorting: true,
      cell: ({ row }) => row.original.date ?? "",
    },
    {
      header: "Confirmation #",
      accessorKey: "confirmationNumber",
      enableSorting: true,
      cell: ({ row }) => row.original.confirmationNumber ?? "",
    },
    {
      header: "Company",
      accessorKey: "companyName",
      enableSorting: true,
      cell: ({ row }) => row.original.companyName,
    },
    {
      header: "Intacct ID",
      accessorKey: "intacctId",
      enableSorting: true,
      cell: ({ row }) => row.original.intacctId ?? "",
    },
    {
      header: "Event",
      accessorKey: "eventName",
      enableSorting: true,
      cell: ({ row }) => row.original.eventName,
    },
    {
      header: "Session",
      accessorKey: "sessionName",
      enableSorting: true,
      cell: ({ row }) => row.original.sessionName,
    },
    {
      header: "Type",
      accessorKey: "type",
      enableSorting: true,
      cell: ({ row }) => row.original.type,
    },
    {
      header: "Seats Paid",
      accessorKey: "seatsPaid",
      enableSorting: true,
      cell: ({ row }) => row.original.seatsPaid,
    },
    {
      header: "Seats Voucher",
      accessorKey: "seatsVoucher",
      enableSorting: true,
      cell: ({ row }) => row.original.seatsVoucher,
    },
    {
      header: "Gross",
      accessorKey: "gross",
      cell: ({ row }) => `$${row.original.gross}`,
    },
    {
      header: "Discount",
      accessorKey: "discount",
      cell: ({ row }) => `$${row.original.discount}`,
    },
    {
      header: "Net",
      accessorKey: "net",
      enableSorting: true,
      cell: ({ row }) => `$${row.original.net}`,
    },
    {
      header: "Payment Method",
      accessorKey: "paymentMethod",
      cell: ({ row }) => row.original.paymentMethod ?? "",
    },
    {
      header: "Status",
      accessorKey: "status",
      enableSorting: true,
      cell: ({ row }) => row.original.status,
    },
  ];
}
